import ServiceError from '../../../core/errors/ServiceError';
import getTypeVideoByUrl from '../../../utils/urlVideoUtils';

export default function parserPOCPlaylist(targetId, pocData) {
  const dataParsed = [];
  const dataPlaylist = pocData?.contents?.video;

  let i = 0;
  if (Array.isArray(dataPlaylist)) {
    const contents = dataPlaylist.filter((item) => item['@attributes'].type === 'content');

    contents.forEach((item) => {
      const videoData = {};
      videoData.index = i;
      videoData.id = item.id;
      i += 1;

      let urlVideo = item.urlHtml;
      if (urlVideo.match(/^\/\//)) {
        urlVideo = `https:${urlVideo}`;
      }
      videoData.isVideoProducer = urlVideo.match(
        '^(http(s)?:)?//videoproducer.b-cdn.net/(.*).json$',
      );
      videoData.isYoutube = urlVideo?.includes('youtube');
      if (videoData.isVideoProducer) {
        videoData.urlVideoProducer = urlVideo;
      } else {
        videoData.url = urlVideo;
      }
      videoData.idVideoElement = `${targetId}_${videoData.id}_video`;
      videoData.idYoutubeElement = `${targetId}_${videoData.id}_youtube`;
      const urlConfiguration = getTypeVideoByUrl(urlVideo, false);
      videoData.typeFactory = urlConfiguration.type;
      videoData.url = urlConfiguration.idVideo;
      videoData.title = item.title;
      videoData.description = item.description;
      videoData.thumb = item.picture;

      dataParsed.push(videoData);
    });
  } else {
    throw new ServiceError('No contents into POC service', '05011');
  }
  return dataParsed;
}
